import styled from 'styled-components';
import { mediaTemplates } from 'theme/variables';
import Text from 'components/Text';

export default styled.div`
  flex-shrink: 0;

  ${Text} {
    height: 100%;
    line-height: 20px;
    max-height: 60px;
    -webkit-line-clamp: 3;
    
    * {
      margin: 0;
      padding: 0;
    }

    ${mediaTemplates.xxs}, ${mediaTemplates.l} {
      max-height: 80px;
      -webkit-line-clamp: 4;
    }
  }
`;
